import React from "react";
import { useTranslation } from "react-i18next";

export default function PostHogReporting({ status }) {
  const { t } = useTranslation();
  const url = /^https:\/\/(us|eu)\.posthog\.com(?:\/project\/\d+)?$/.test(status.dashboard_url || "")
    ? status.dashboard_url : "https://us.posthog.com";
  const trials = status.trial_conversion;
  return (
    <section className="space-y-6" data-testid="posthog-reporting">
      <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-6 text-white">
        <h2 className="text-xl mb-3">{t("posthogReporting.title")}</h2>
        <p className="text-white/70 mb-4">
          {t("posthogReporting.description")}
        </p>
        {status.configured === false && <p className="text-amber-200 mb-4">{t("posthogReporting.incomplete")}</p>}
        <a href={url} target="_blank" rel="noopener noreferrer"
          className="inline-block rounded-full bg-[#D4B483] px-5 py-2 text-[#1A1720]">{t("posthogReporting.open")}</a>
      </div>
      {trials && <div className="rounded-2xl border border-white/10 p-6 text-white">
        <h2 className="text-xl mb-3">{t("posthogReporting.trials", { days: status.window_days })}</h2>
        <p className="text-white/70 mb-4">{t("posthogReporting.records")}</p>
        <div className="flex flex-wrap gap-6">
          <p>{t("posthogReporting.started")} <strong>{trials.started ?? 0}</strong></p>
          <p>{t("posthogReporting.converted")} <strong>{trials.outcomes?.converted_to_paid ?? 0}</strong></p>
          <p>{t("posthogReporting.canceled")} <strong>{trials.outcomes?.canceled_before_payment ?? 0}</strong></p>
          <p>{t("posthogReporting.conversion")} <strong>{trials.conversion_pct == null ? "—" : `${trials.conversion_pct}%`}</strong></p>
        </div>
        <a href="/admin/users" className="inline-block text-[#D4B483] mt-4 underline">{t("posthogReporting.customers")}</a>
      </div>}
    </section>
  );
}
